// src/pages/micuenta/EditarEmpleo.jsx
import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import MiCuentaEmpleadorMenu from "./MiCuentaEmpleadorMenu";
import "./publicarempleo.css"; // Reutilizamos estilos

function EditarEmpleo() {
  const { user } = useContext(AuthContext);
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [jobData, setJobData] = useState(null);

  useEffect(() => {
    if (!user || user.userType !== "employer") return;
    const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
    const foundJob = storedJobs.find((j) => j.id.toString() === jobId);
    if (foundJob) {
      setJobData(foundJob);
    } else {
      alert("Empleo no encontrado.");
      navigate(-1);
    }
  }, [user, jobId, navigate]);

  // Estados locales para cada campo
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [requirements, setRequirements] = useState("");
  const [benefits, setBenefits] = useState("");
  const [modality, setModality] = useState("");
  const [workLanguage, setWorkLanguage] = useState("");
  const [visaRequirement, setVisaRequirement] = useState("");
  const [jobType, setJobType] = useState("");
  const [salary, setSalary] = useState("");
  const [highlight, setHighlight] = useState(false);

  // Nuevo: permitir 3 opciones de estado
  const [status, setStatus] = useState("Borrador");

  // Al montar (y cuando jobData cambie), rellenamos los estados
  useEffect(() => {
    if (jobData) {
      setTitle(jobData.title || "");
      setDescription(jobData.description || "");
      setRequirements(jobData.requirements || "");
      setBenefits(jobData.benefits || "");
      setModality(jobData.modality || "");
      setWorkLanguage(jobData.workLanguage || "");
      setVisaRequirement(jobData.visaRequirement || "");
      setJobType(jobData.jobType || "");
      setSalary(jobData.salary || "");
      setHighlight(jobData.highlight || false);
      setStatus(jobData.status || "Borrador");
    }
  }, [jobData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!jobData) return;

    // Actualizamos el objeto con los nuevos valores
    const updatedJob = {
      ...jobData,
      title,
      description,
      requirements,
      benefits,
      modality,
      workLanguage,
      visaRequirement,
      jobType,
      salary,
      highlight,
      status, // Nuevo: guardamos el estado actualizado
    };

    const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
    const newJobs = storedJobs.map((j) =>
      j.id === updatedJob.id ? updatedJob : j
    );
    localStorage.setItem("jobs", JSON.stringify(newJobs));

    alert("Empleo actualizado correctamente.");
    navigate(`/mi-cuenta/empleos-publicados/detalles-empleo/${jobId}`);
  };

  if (!user || user.userType !== "employer") {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Acceso denegado</h2>
          <p>Debes ser empleador para editar un empleo.</p>
        </div>
      </div>
    );
  }

  if (!jobData) {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Cargando empleo...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="register-container">
      <div className="register-card">
        <MiCuentaEmpleadorMenu user={user} />
        <h2 className="register-title">Editar Empleo</h2>
        <form onSubmit={handleSubmit} className="register-form">
          {/* Título */}
          <div className="form-group">
            <label>
              Título del Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Descripción */}
          <div className="form-group">
            <label>
              Descripción del Puesto <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <textarea
                className="form-control"
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Requisitos */}
          <div className="form-group">
            <label>
              Requisitos del Empleo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <textarea
                className="form-control"
                rows={3}
                value={requirements}
                onChange={(e) => setRequirements(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Beneficios */}
          <div className="form-group">
            <label>
              Beneficios del Empleo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <textarea
                className="form-control"
                rows={2}
                value={benefits}
                onChange={(e) => setBenefits(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Modalidad */}
          <div className="form-group">
            <label>
              Modalidad de Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={modality}
                onChange={(e) => setModality(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Remoto">Remoto</option>
                <option value="On-Site">On-Site</option>
                <option value="Semi-remoto">Semi-remoto</option>
              </select>
            </div>
          </div>

          {/* Idioma del Trabajo */}
          <div className="form-group">
            <label>
              Idioma del Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={workLanguage}
                onChange={(e) => setWorkLanguage(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Español">Español</option>
                <option value="Inglés">Inglés</option>
                <option value="Ambos">Ambos</option>
              </select>
            </div>
          </div>

          {/* Requisito de Visa */}
          <div className="form-group">
            <label>
              Requisito de Visa <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={visaRequirement}
                onChange={(e) => setVisaRequirement(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Visa requerida">Visa requerida</option>
                <option value="Patrocinio disponible">Patrocinio disponible</option>
              </select>
            </div>
          </div>

          {/* Tipo de Trabajo */}
          <div className="form-group">
            <label>
              Tipo de Trabajo <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={jobType}
                onChange={(e) => setJobType(e.target.value)}
                required
              >
                <option value="">Selecciona</option>
                <option value="Tiempo completo">Tiempo completo</option>
                <option value="Medio tiempo">Medio tiempo</option>
                <option value="Freelance">Freelance</option>
                <option value="Contrato">Contrato</option>
              </select>
            </div>
          </div>

          {/* Salario */}
          <div className="form-group">
            <label>
              Salario <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <input
                type="text"
                className="form-control"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Destacar Empleo */}
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={highlight}
                onChange={(e) => setHighlight(e.target.checked)}
              />{" "}
              Destacar Empleo
            </label>
          </div>

          {/* Nuevo: Estado del Empleo (Borrador, Publicado, Cerrado) */}
          <div className="form-group">
            <label>
              Estado <span className="required">*</span>
            </label>
            <div className="input-wrapper">
              <select
                className="form-control select-arrow"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                required
              >
                 <option value="Seleccionar">Seleccionar</option>
                <option value="Borrador">Borrador</option>
                <option value="Publicado">Publicado</option>
              </select>
            </div>
          </div>

          <button type="submit" className="submit-button">
            Actualizar Empleo
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditarEmpleo;